module.exports = __webpack_public_path__ + "assets/img/damien.00d7784b.png";